module.exports = __webpack_public_path__ + "img/bg-home.ac8ac35f.png";